import type { TypographyProps } from '@/shared-ui/atoms/typography';

/** Typography variants exposed on the Menu Item Page Designer component. */
export const MENU_ITEM_TEXT_VARIANT_VALUES = [
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'large',
    'small',
    'caption',
    'span',
    'p',
] as const satisfies readonly NonNullable<TypographyProps['variant']>[];

export type MenuItemTextVariant = (typeof MENU_ITEM_TEXT_VARIANT_VALUES)[number];

export const DEFAULT_MENU_ITEM_TEXT_VARIANT: MenuItemTextVariant = 'h3';

export const DEFAULT_MENU_ITEM_ICON_SIZE_PX = 16;
export const MIN_MENU_ITEM_ICON_SIZE_PX = 8;
export const MAX_MENU_ITEM_ICON_SIZE_PX = 48;

export function parseMenuItemTextVariant(value: unknown): MenuItemTextVariant | undefined {
    if (typeof value === 'string' && (MENU_ITEM_TEXT_VARIANT_VALUES as readonly string[]).includes(value)) {
        return value as MenuItemTextVariant;
    }

    return undefined;
}

export function parseMenuItemIconSizePx(value: unknown): number | undefined {
    const parsed =
        typeof value === 'number'
            ? value
            : typeof value === 'string' && value.trim()
              ? Number.parseInt(value, 10)
              : Number.NaN;

    if (!Number.isFinite(parsed)) {
        return undefined;
    }

    const rounded = Math.round(parsed);
    if (rounded < MIN_MENU_ITEM_ICON_SIZE_PX || rounded > MAX_MENU_ITEM_ICON_SIZE_PX) {
        return undefined;
    }

    return rounded;
}

export function parseMenuItemRemoveHorizontalPadding(value: unknown): boolean {
    return value === true;
}
